/* ============================================================================
   kitsters-vanity-url.js - cosmetic address-bar rewrite for a vanity URL.

   WHY THIS EXISTS, and why it is not a redirect.

   Shopify hardcodes the `/pages/` prefix, so the Magic Hour page genuinely
   lives at /pages/magic-hour and nothing theme-side can move it (§10.65 is the
   same fact seen from /policies/*). A Shopify URL redirect solves the inbound
   direction only - /magic-hour -> /pages/magic-hour, live since 2026-08-20 -
   and it CANNOT be pointed the other way:

     - Shopify gives an existing resource priority over any redirect on its
       path, so a redirect on /pages/magic-hour is accepted, shows up in Admin,
       and never fires. Proven on this store rather than quoted: a redirect
       /collections/all -> /collections/shop-all-diy-kits has existed for
       months and /collections/all still returns 200. That is the "inert
       rather than poisonous" shape of §10.92/§10.96 - it would read as a
       working feature forever.
     - And if it did fire it would point at /magic-hour, which points back
       here: an infinite loop that takes the page offline.

   So the address bar is rewritten client-side instead. The page is served
   normally at /pages/magic-hour and only the DISPLAYED url changes, which is
   what the owner asked for (2026-08-20: "The page link should be
   kitsters.in/magic-hour").

   WHAT THIS DELIBERATELY DOES NOT CHANGE
   - The canonical stays /pages/magic-hour. That is the real url and the
     correct canonical; do not "fix" it to match the bar (§10.65's lesson that
     routing is the platform's, not ours).
   - Analytics still attributes the hit to /pages/magic-hour, because every
     tag fires on load, before this runs. Accepted knowingly - see docs/19
     §MH-URL. Do not "fix" that by re-firing a pageview; that double-counts.

   SAFETY
   - replaceState, never pushState: no history entry is added, so Back still
     goes to the previous page rather than trapping the shopper here.
   - A refresh re-requests /magic-hour, which 301s back here and re-runs this,
     so the short url is stable across reloads and copy-paste.
   - Nothing on this page reads location.pathname (audited 2026-08-20; the one
     hit in the theme is on the Magic Hour PRODUCT template, which this never
     runs on - see the Liquid gate in snippets/kitsters-vanity-url.liquid).
   ========================================================================= */
(function () {
  'use strict';

  var tag = document.querySelector('script[data-kt-vanity]');
  if (!tag) return;

  var vanity = tag.getAttribute('data-kt-vanity');
  var real = tag.getAttribute('data-kt-real');
  if (!vanity || !real) return;

  if (!window.history || typeof window.history.replaceState !== 'function') return;

  /* Belt: the Liquid gate already guarantees this, but a cached/rewritten
     document could disagree. Never rewrite from a path we were not told about. */
  if (window.location.pathname !== real) return;

  try {
    window.history.replaceState(
      window.history.state,
      '',
      vanity + window.location.search + window.location.hash
    );
  } catch (e) {
    /* Sandboxed or cross-origin document - leave the url exactly as it is.
       The page is fully functional either way; this is cosmetic only. */
  }
})();
